class EntityPreferencesController {
  constructor(entityService, loadingService, $ngConfirm, growl) {
    "ngInject"

    this.entityService = entityService;
    this.loadingService = loadingService;
    this.$ngConfirm = $ngConfirm;
    this.growl = growl;

    this.selectedLocationId = null;
    this.selectedPref = null;
    this.locations = [];

    this.initializeLocations();
  }

  initializeLocations(){
    this.entityService.listAllLocations()
      .then(response => {
        const firstItem = {
          entityId: null,
          name: '---- Select Location ----'
        };

        this.locations = [firstItem, ...response.data.items];
      });
  }

  loadPreferences() {
    if (!this.selectedLocationId) {
      return;
    }

    this.loadingService.showLoading('entityPrefs', 'Loading Preferences ...');

    this.entityService.getEntityPreferences(this.selectedLocationId)
      .then(response => {      
        this.selectedPref = response.data;
      })
      .finally(() => {
        this.loadingService.hideLoading('entityPrefs');
      });    
  }

  confirmSavePreferences() {
    this.$ngConfirm({
      title: "Confirm",
      content: `Are you sure want to save changes ?`,
      type: 'orange',
      buttons: {
        ok: {
          text: 'Save Changes',
          btnClass: 'btn-primary',
          action: () => {
            this.savePreferences();
          }
        },
        cancel: {
          text: 'Leave it',
          btnClass: 'btn-default',
          action: () => {}
        }
      }
    });
  }

  savePreferences() {
    this.loadingService.showLoading('entityPrefs', 'Saving Preferences ...');

    this.entityService.updateEntityPreferences(this.selectedPref)
      .then(response => {      
        this.growl.success('Changes saved successfully', {ttl: 5000});
      })
      .finally(() => {
        this.loadingService.hideLoading('entityPrefs');
      }); 
  }
}

export default EntityPreferencesController;



// WEBPACK FOOTER //
// ./client/app/components/admin/entityPreferences/entityPreferences.controller.js